import React, { Component } from 'react';
import Container from '@/components/Container';
import Iframe from '@/components/Iframe';

export default class BaseCreateNotice extends Component {
  render() {
    const IframeDom = Iframe({
      src: '//t.xiaoyuanhao.com/v2/iframe/areaCountyNotice/school/create',
      defaultPadding: true,
    });

    return (
      <Container breStates defaultPadding>
        <IframeDom />
      </Container>
    );
  }
}
